import { type AlgoliaRecord } from '../../algolia'

import {
  SERP_POSITION_FIFTEEN,
  SERP_POSITION_FIVE,
  SERP_POSITION_THIRTY,
} from './productSearchSerpPositions'

type ProductSearchOwnBrandHits = {
  obHits: number
  obTop15?: number
  obTop30?: number
  obTop5?: number
}

type OwnBrandRecord = Pick<AlgoliaRecord, 'own_brand'>

type OwnBrandCounters = Required<ProductSearchOwnBrandHits>

const recordIsOwnBrand = (record: OwnBrandRecord): boolean => {
  return record.own_brand === true
}

const createEmptyCounters = (): OwnBrandCounters => {
  return {
    obHits: 0,
    obTop15: 0,
    obTop30: 0,
    obTop5: 0,
  }
}

const increaseCountersIfInThreshold = (
  counters: OwnBrandCounters,
  index: number,
): void => {
  if (index < SERP_POSITION_FIVE) {
    counters.obTop5 += 1
  }

  if (index < SERP_POSITION_FIFTEEN) {
    counters.obTop15 += 1
  }

  if (index < SERP_POSITION_THIRTY) {
    counters.obTop30 += 1
  }
}

const buildResultForPage = (
  counters: OwnBrandCounters,
  pageNumber: number,
): ProductSearchOwnBrandHits => {
  const isFirstPage = pageNumber === 1

  if (!isFirstPage) {
    return { obHits: counters.obHits }
  }

  return {
    obHits: counters.obHits,
    obTop15: counters.obTop15,
    obTop30: counters.obTop30,
    obTop5: counters.obTop5,
  }
}

export const productSearchGetOwnBrandHits = (
  hits: OwnBrandRecord[],
  pageNumber: number,
): ProductSearchOwnBrandHits => {
  const counters = createEmptyCounters()

  const isFirstPage = pageNumber === 1

  for (const [index, hit] of hits.entries()) {
    if (recordIsOwnBrand(hit)) {
      counters.obHits += 1

      if (isFirstPage) {
        increaseCountersIfInThreshold(counters, index)
      }
    }
  }

  return buildResultForPage(counters, pageNumber)
}
